module.exports = __webpack_public_path__ + "img/html.4a879dee.png";